export class AuthServiceModel {

    id: string;
    nome: string;
    cpfCnpj: string;
    email: string;
    fgInternoExterno: string;
    fgSenhaTemporaria: string;
    fgBloqueado: string;
    serviceContract: string;
    telefone: string;
    telefoneCelular: string;
    codigoEps: string;
    sistemas: [
        {
            codigo: number,
            permissao: number
        }
    ];
    sessionToken: string;
    payload: string;
    roles: string[];
    error: boolean;
    message: string;
    isOtpEnabled: boolean;
    otpDetails: OTPDetails;
}

export class OTPDetails {
  correlationId: string;
}

export class CheckOtpModel {
    isOtpEnabled: boolean;
    email: string;
    telefoneCelular: string;
}
